import { render, staticRenderFns } from "./MobileAbout.vue?vue&type=template&id=1d2d9e48"
import script from "./MobileAbout.vue?vue&type=script&lang=js"
export * from "./MobileAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports